import React from 'react';
import '../../App.css';
import './Sobremi.css';
import Footer from '../Footer';
import { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { Button } from '../button';
import ThreeColumnWithProfileImage from '../ThreeColumnWithProfileImage';
import {Helmet} from "react-helmet";

function Sobremi () {
    const { Sobremi } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [Sobremi]);

    return (
        <>
         <Helmet>
          <meta charSet='utf-8'/>
          <title>Tekins | Sobre Nosotros</title>
          <meta name="description" content= "Conoce al equipo multidisciplinario de Tekins y la forma en que combinamos estrategia, diseño y tecnología." />
          <meta name="robots" content= "index, follow"></meta>
        </Helmet>
        <div className='header'> 
        <h1>Sobre nosotros</h1> 
        </div>

        <div className='sobre'>
        <div className='sobre-row'>

        
        <div className='sobre-col'>
           <div className='sobre-col-content'>   
                   <p>Tekins nació como un laboratorio de ideas donde la estrategia, el diseño y la tecnología conviven desde el primer boceto. Creemos en las marcas que se escuchan, se miden y se transforman de forma constante. Por eso construimos equipos híbridos que piensan en negocio y en personas al mismo tiempo.</p>
                   <p>Hoy trabajamos con empresas que buscan crecer de forma sostenible. Nos apasiona traducir retos complejos en planes accionables, conectando datos, creatividad y prototipos funcionales.</p>
                      </div>
</div>
        <div className='sobre-col-r'>
          <div className='sobre-row-ima'> 
                <img class="sobre-imagen-p" 
                src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=900&q=80" 
                alt="Equipo Tekins reunido"/>
          </div>
        </div>
</div>

</div>
<div className='sobre-centro'>
                  
                  <h2>Nuestra historia</h2>
                   <p>Comenzamos como un pequeño equipo remoto que quería desafiar la forma tradicional de trabajar el marketing digital. Con el tiempo entendimos que el verdadero diferencial estaba en integrar capacidades estratégicas, creativas y tecnológicas en un mismo flujo de trabajo. Desde Panamá coordinamos talento en distintos países de Latinoamérica y Estados Unidos.</p>
                   <p>Somos inquietos por naturaleza, aprendemos rápido y nos movemos con metodologías ágiles para entregar valor en cada iteración.</p>
                      <h2>Nuestro equipo</h2>
  </div>

  <div className='sobre'>
        <div className='sobre-row'> 

        
        <div className='sobre-col'>
        <div className='sobre-row-ima'> 
                <img class="sobre-imagen-r" 
                src="https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=900&q=80" 
                alt="Estrategia de datos Tekins"/>
          </div>
</div>
        <div className='sobre-col-r'>

        <div className='sobre-col-content'>   
                   <p>Nuestro capítulo de estrategia y datos combina especialistas en investigación de mercados, ciencia de datos y growth marketing. Son quienes traduce la información en decisiones de negocio claras, modelan escenarios y acompañan a las marcas a medir lo que importa.</p>
                      </div>
      
        </div>
</div>

</div>
<div className='sobre'>
        <div className='sobre-row'>

        
        <div className='sobre-col'>
        <div className='sobre-row-ima'> 
                <img class="sobre-imagen-r" 
                src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=900&q=80" 
                alt="Diseño y tecnología Tekins"/>
          </div>
        
           
</div>
        <div className='sobre-col-r'>
        <div className='sobre-col-content'> 
        <p>El equipo de diseño y experiencias de Tekins crea sistemas visuales flexibles, prototipa interfaces y vela por la coherencia de cada punto de contacto. Trabajamos en conjunto con developers y estrategas para que cada entrega sea tan funcional como estética.</p>
        </div>
        
                     
        </div>
</div>

</div>


        <Footer/>
        </>
    );
}

export default Sobremi;
